<mat-dialog-content>
  <div class="card mt-3" *ngIf="isQuota()">
    <div class="card-header text-uppercase">Estoque de Fundos</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-2">
          <label>Data da Posição</label>
          <input
            type="text"
            class="form-control"
            name="stockDate"
            data-cy="stockDate"
            [(ngModel)]="stockDataFunds.positionDate"
            readonly
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <h6 *ngIf="stockDataFunds?.positions == null">
            Aguarde o carregamento dos dados...
          </h6>
          <h6 *ngIf="stockDataFunds?.positions?.length == 0">
            Não foram encontrados dados de estoque para esta carteira.
          </h6>
          <div
            class="table-container"
            style="padding-top: 15px"
            *ngIf="stockDataFunds?.positions?.length > 0"
          >
            <table
              mat-table
              [dataSource]="stockDataFunds.positions"
              class="col-12"
            >
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>Selecionar</th>
                <td mat-cell *matCellDef="let element">
                  <a (click)="selectFund(element)"
                    ><fa-icon
                      [icon]="faCircleCheck"
                      title="Selecionar"
                    ></fa-icon
                  ></a>
                </td>
              </ng-container>

              <ng-container matColumnDef="fundSourceId">
                <th mat-header-cell *matHeaderCellDef>Código do Fundo</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.fundSourceId }}
                </td>
              </ng-container>

              <ng-container matColumnDef="fundName">
                <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.fundName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="institutionName">
                <th mat-header-cell *matHeaderCellDef>Nome da Instituição</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.institutionName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="availableQuantity">
                <th mat-header-cell *matHeaderCellDef>Quantidade Disponível</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.availableQuantity }}
                </td>
              </ng-container>

              <ng-container matColumnDef="quotaValue">
                <th mat-header-cell *matHeaderCellDef>Valor da Cota</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.quotaValue | currency: "R$":"symbol":"1.8-8" }}
                </td>
              </ng-container>

              <ng-container matColumnDef="netValue">
                <th mat-header-cell *matHeaderCellDef>Valor Líquido</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.netValue | currency: "R$":"symbol":"1.2-2" }}
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="columnsFund; sticky: true"
              ></tr>
              <tr mat-row *matRowDef="let row; columns: columnsFund"></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3" *ngIf="isFixedIncome()">
    <div class="card-header text-uppercase">Estoque de Renda Fixa</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-2">
          <label>Data da Posição</label>
          <input
            type="text"
            class="form-control"
            name="stockDate"
            data-cy="stockDate"
            [(ngModel)]="stockDataFixedIncome.positionDate"
            readonly
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <h6 *ngIf="stockDataFixedIncome?.positions == null">
            Aguarde o carregamento dos dados...
          </h6>
          <h6 *ngIf="stockDataFixedIncome?.positions?.length == 0">
            Não foram encontrados dados de estoque para esta carteira.
          </h6>
          <div
            class="table-container"
            style="padding-top: 15px"
            *ngIf="stockDataFixedIncome?.positions?.length > 0"
          >
            <table
              mat-table
              [dataSource]="stockDataFixedIncome.positions"
              class="col-12"
            >
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>Selecionar</th>
                <td mat-cell *matCellDef="let element">
                  <a (click)="selectFixedIncome(element)"
                    ><fa-icon
                      [icon]="faCircleCheck"
                      title="Selecionar"
                    ></fa-icon
                  ></a>
                </td>
              </ng-container>
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>Código RF</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.code }}
                </td>
              </ng-container>
              <ng-container matColumnDef="selicCode">
                <th mat-header-cell *matHeaderCellDef>Código Selic</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.selicCode }}
                </td>
              </ng-container>
              <ng-container matColumnDef="operationCode">
                <th mat-header-cell *matHeaderCellDef>Código da Operação</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.operationCode }}
                </td>
              </ng-container>
              <ng-container matColumnDef="purchaseDate">
                <th mat-header-cell *matHeaderCellDef>Data da Compra</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.purchaseDate | date: "dd/MM/yyyy":"GMT" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="issueCode">
                <th mat-header-cell *matHeaderCellDef>Emissão</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.issueCode }}
                </td>
              </ng-container>
              <ng-container matColumnDef="issuerName">
                <th mat-header-cell *matHeaderCellDef>Emissor</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.issuerName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="serie">
                <th mat-header-cell *matHeaderCellDef>Série</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.serie }}
                </td>
              </ng-container>
              <ng-container matColumnDef="issueDate">
                <th mat-header-cell *matHeaderCellDef>Data de Emissão</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.issueDate | date: "dd/MM/yyyy":"GMT" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="dueDate">
                <th mat-header-cell *matHeaderCellDef>Data de Vencimento</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.dueDate | date: "dd/MM/yyyy":"GMT" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.quantity }}
                </td>
              </ng-container>
              <ng-container matColumnDef="pu">
                <th mat-header-cell *matHeaderCellDef>PU</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.pu | currency: "R$":"symbol":"1.8-8" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="purchaseValue">
                <th mat-header-cell *matHeaderCellDef>Valor de Compra</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.purchaseValue | currency: "R$":"symbol":"1.2-2" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="netValue">
                <th mat-header-cell *matHeaderCellDef>Valor Líquido</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.netValue | currency: "R$":"symbol":"1.2-2" }}
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="columnsFixedIncome; sticky: true"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: columnsFixedIncome"
              ></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3" *ngIf="isContracted()">
    <div class="card-header text-uppercase">Estoque de Renda Fixa Compromissada.</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-2">
          <label>Data da Posição</label>
          <input
            type="text"
            class="form-control"
            name="stockDate"
            data-cy="stockDate"
            [(ngModel)]="stockDataFixedIncome.positionDate"
            readonly
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <h6 *ngIf="stockDataFixedIncome?.committedPositions == null">
            Aguarde o carregamento dos dados...
          </h6>
          <h6 *ngIf="stockDataFixedIncome?.committedPositions?.length == 0">
            Não foram encontrados dados de estoque para esta carteira.
          </h6>
          <div
            class="table-container"
            style="padding-top: 15px"
            *ngIf="stockDataFixedIncome?.committedPositions?.length > 0"
          >
            <table
              mat-table
              [dataSource]="stockDataFixedIncome.committedPositions"
              class="col-12"
            >
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>Selecionar</th>
                <td mat-cell *matCellDef="let element">
                  <a (click)="selectFixedIncomeComitted(element)"
                    ><fa-icon
                      [icon]="faCircleCheck"
                      title="Selecionar"
                    ></fa-icon
                  ></a>
                </td>
              </ng-container>
              <ng-container matColumnDef="operationCode">
                <th mat-header-cell *matHeaderCellDef>Código da Operação</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.operationCode }}
                </td>
              </ng-container>
              <ng-container matColumnDef="purchaseDate">
                <th mat-header-cell *matHeaderCellDef>Data da Compra</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.purchaseDate | date: "dd/MM/yyyy":"GMT" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="securityName">
                <th mat-header-cell *matHeaderCellDef>Nome Segurança</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.securityName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="originalDate">
                <th mat-header-cell *matHeaderCellDef>Data Original</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.originalDate | date: "dd/MM/yyyy":"GMT" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="dueDate">
                <th mat-header-cell *matHeaderCellDef>Data de Vencimento</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.dueDate | date: "dd/MM/yyyy":"GMT" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="issuerName">
                <th mat-header-cell *matHeaderCellDef>Emissor</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.issuerName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef>Quantidade</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.quantity }}
                </td>
              </ng-container>
              <ng-container matColumnDef="pu">
                <th mat-header-cell *matHeaderCellDef>PU</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.pu | currency: "R$":"symbol":"1.8-8" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="purchaseValue">
                <th mat-header-cell *matHeaderCellDef>Valor de Compra</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.purchaseValue | currency: "R$":"symbol":"1.2-2" }}
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="columnsFixedIncomeCommitted; sticky: true"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: columnsFixedIncomeCommitted"
              ></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3" *ngIf="isVariableIncome()">
    <div class="card-header text-uppercase">Estoque de Renda Variável</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-2">
          <label>Data da Posição</label>
          <input
            type="text"
            class="form-control"
            name="stockDate"
            data-cy="stockDate"
            [(ngModel)]="stockDataVariableIncome.positionDate"
            readonly
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <h6 *ngIf="stockDataVariableIncome?.positions == null">
            Aguarde o carregamento dos dados...
          </h6>
          <h6 *ngIf="stockDataVariableIncome?.positions?.length == 0">
            Não foram encontrados dados de estoque para esta carteira.
          </h6>
          <div
            class="table-container"
            style="padding-top: 15px"
            *ngIf="stockDataVariableIncome?.positions?.length > 0"
          >
            <table
              mat-table
              [dataSource]="stockDataVariableIncome.positions"
              class="col-12"
            >
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>Selecionar</th>
                <td mat-cell *matCellDef="let element">
                  <a (click)="selectVariableIncome(element)"
                    ><fa-icon
                      [icon]="faCircleCheck"
                      title="Selecionar"
                    ></fa-icon
                  ></a>
                </td>
              </ng-container>
              <ng-container matColumnDef="assetCode">
                <th mat-header-cell *matHeaderCellDef>Cód. Ativo</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.assetCode }}
                </td>
              </ng-container>
              <ng-container matColumnDef="assetName">
                <th mat-header-cell *matHeaderCellDef>Nome Ativo</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.assetName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="availableAmount">
                <th mat-header-cell *matHeaderCellDef>Qtd. Disponível</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.availableAmount }}
                </td>
              </ng-container>
              <ng-container matColumnDef="blockedAmount">
                <th mat-header-cell *matHeaderCellDef>Qtd. Bloqueada</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.blockedAmount }}
                </td>
              </ng-container>
              <ng-container matColumnDef="totalAmount">
                <th mat-header-cell *matHeaderCellDef>Qtd. Total</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.totalAmount }}
                </td>
              </ng-container>
              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef>Cotação</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.price | currency: "R$":"symbol":"1.8-8" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="totalCost">
                <th mat-header-cell *matHeaderCellDef>Custo Total</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.totalCost | currency: "R$":"symbol":"1.2-2" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="result">
                <th mat-header-cell *matHeaderCellDef>Resultado</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.result | currency: "R$":"symbol":"1.2-2" }}
                </td>
              </ng-container>
              <ng-container matColumnDef="netValue">
                <th mat-header-cell *matHeaderCellDef>Valor Líquido</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.netValue | currency: "R$":"symbol":"1.2-2" }}
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="columnsVariableIncome; sticky: true"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: columnsVariableIncome"
              ></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3" *ngIf="isLiabilities()">
    <div class="card-header text-uppercase">Estoque de Fundos (Cotistas)</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-2">
          <label>Data da Posição</label>
          <input
            type="text"
            class="form-control"
            name="stockDate"
            data-cy="stockDate"
            [(ngModel)]="stockDataShareholdersFunds.positionDate"
            readonly
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <h6 *ngIf="stockDataShareholdersFunds?.positions == null">
            Aguarde o carregamento dos dados...
          </h6>
          <h6 *ngIf="stockDataShareholdersFunds?.positions?.length == 0">
            Não foram encontrados dados de estoque para esta carteira.
          </h6>
          <div
            class="table-container"
            style="padding-top: 15px"
            *ngIf="stockDataShareholdersFunds?.positions?.length > 0"
          >
            <div
              class="card mt-3"
              *ngFor="let position of stockDataShareholdersFunds.positions"
            >
              <div class="card-header text-uppercase">
                {{ position.fundSourceId }} - {{ position.fundName }}
              </div>
              <div class="card-body">
                <table
                  mat-table
                  [dataSource]="position.invoices"
                  class="col-12"
                >
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>Selecionar</th>
                    <td mat-cell *matCellDef="let element">
                      <a (click)="selectShareholderFund(element)"
                        ><fa-icon
                          [icon]="faCircleCheck"
                          title="Selecionar"
                        ></fa-icon
                      ></a>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="invoiceId">
                    <th mat-header-cell *matHeaderCellDef>Nº Nota</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.invoiceId }}
                    </td>
                  </ng-container>

                  <!-- <ng-container matColumnDef="settlementStockDetainer">
                    <th mat-header-cell *matHeaderCellDef>
                      Liquid. / Estoque / Custódia
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.settlementStockDetainer }}
                    </td>
                  </ng-container> -->

                  <ng-container matColumnDef="applicationDate">
                    <th mat-header-cell *matHeaderCellDef>Data Operação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.applicationDate | date: "dd/MM/yyyy":"GMT" }}
                    </td>
                  </ng-container>

                  <!-- <ng-container matColumnDef="settlementDate">
                    <th mat-header-cell *matHeaderCellDef>Data Liquidação</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.settlementDate | date: "dd/MM/yyyy":"GMT" }}
                    </td>
                  </ng-container> -->

                  <ng-container matColumnDef="quotaAmount">
                    <th mat-header-cell *matHeaderCellDef>Qtd. Cotas</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.quotaAmount }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="applicationValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Aplicação</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.applicationValue
                          | currency: "R$":"symbol":"1.2-2"
                      }}
                    </td>
                  </ng-container>

                  <!-- <ng-container matColumnDef="correctedValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Corrigido</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.correctedValue | currency: "R$":"symbol":"1.2-2"
                      }}
                    </td>
                  </ng-container> -->

                  <!-- <ng-container matColumnDef="iofValue">
                    <th mat-header-cell *matHeaderCellDef>Provisão IOF</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.iofValue | currency: "R$":"symbol":"1.2-2" }}
                    </td>
                  </ng-container> -->

                  <!-- <ng-container matColumnDef="iofAliquot">
                    <th mat-header-cell *matHeaderCellDef>Alíquota IOF</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.iofAliquot }}
                    </td>
                  </ng-container> -->

                  <!-- <ng-container matColumnDef="iofElapsedDays">
                    <th mat-header-cell *matHeaderCellDef>Prazo Decor. IOF</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.iofElapsedDays }}
                    </td>
                  </ng-container> -->

                  <!-- <ng-container matColumnDef="taxValue">
                    <th mat-header-cell *matHeaderCellDef>Provisão IR</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.taxValue | currency: "R$":"symbol":"1.2-2" }}
                    </td>
                  </ng-container> -->

                  <!-- <ng-container matColumnDef="taxAliquot">
                    <th mat-header-cell *matHeaderCellDef>Alíquota IR</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.taxAliquot }}
                    </td>
                  </ng-container> -->

                  <!-- <ng-container matColumnDef="taxElapsedDays">
                    <th mat-header-cell *matHeaderCellDef>Prazo Decor. IR</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.taxElapsedDays }}
                    </td>
                  </ng-container> -->

                  <ng-container matColumnDef="redemptionValue">
                    <th mat-header-cell *matHeaderCellDef>Valor Resgate</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.redemptionValue
                          | currency: "R$":"symbol":"1.2-2"
                      }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="incomeValue">
                    <th mat-header-cell *matHeaderCellDef>Rendimento</th>
                    <td mat-cell *matCellDef="let element">
                      {{
                        element.incomeValue | currency: "R$":"symbol":"1.2-2"
                      }}
                    </td>
                  </ng-container>

                  <!-- <ng-container matColumnDef="resultPercentage">
                    <th mat-header-cell *matHeaderCellDef>Resultado %</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.resultPercentage | number: "1.2-2" }}
                    </td>
                  </ng-container> -->

                  <ng-container matColumnDef="iofExemptionDate">
                    <th mat-header-cell *matHeaderCellDef>Data Isenção IOF</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.iofExemptionDate | date: "dd/MM/yyyy":"GMT" }}
                    </td>
                  </ng-container>

                  <tr
                    mat-header-row
                    *matHeaderRowDef="columnsShareholderFund; sticky: true"
                  ></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: columnsShareholderFund"
                  ></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
